var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.999 22H4.99902C3.89445 22 2.99902 21.1046 2.99902 20V6C2.99902 4.89543 3.89445 4 4.99902 4H6.99902V2H8.99902V4H14.999V2H16.999V4H18.999C20.1036 4 20.999 4.89543 20.999 6V20C20.999 21.1046 20.1036 22 18.999 22ZM4.99902 10V20H18.999V10H4.99902ZM4.99902 6V8H18.999V6H4.99902Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5be5bb46a1d537787dff725a89c8f139.svg";
export { ForwardRef as ReactComponent };